import { EntityMetadataBuilder, PropertyType } from "clavis-nxt-components-custdevtm";

const METADATA = new EntityMetadataBuilder("EnvironmentConfigurationEntity")
    .entityPath("configurationEnvironment")
    .createProperty("id")
    .propertyType(PropertyType.INTEGER)
    .id()
    .finish()
    .createProperty("configuration")
    .propertyType(PropertyType.INTEGER)
    .finish()
    .createProperty("environmentCode")
    .propertyType(PropertyType.STRING)
    .finish()
    .createProperty("confValue")
    .propertyType(PropertyType.STRING)
    .finish()
    .createProperty("createdBy")
    .propertyType(PropertyType.STRING)
    .finish()
    .createProperty("createdTs")
    .propertyType(PropertyType.DATETIME)
    .finish()
    .createProperty("modifiedBy")
    .propertyType(PropertyType.STRING)
    .finish()
    .createProperty("modifiedTs")
    .propertyType(PropertyType.DATETIME)
    .finish()
    .build();

export default METADATA;
